export const formatearRol = (texto: string) => {
    return texto
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/^./, (c) => c.toUpperCase());
};
